<div class="notas-cards">
    <ng-template [ngIf]="!isLoading && (!notas || notas.length == 0)">
        <div class="alert alert-info" style="max-width: 400px;margin: 15px auto;text-align: center;font-weight: 600;">
            <h5 style="font-weight: 600; margin-bottom: 0px;">
               <i class="fas fa-info" aria-hidden="true"></i> Nenhuma nota encontrada
            </h5>
        </div>
    </ng-template>

    <ng-template [ngIf]="!isLoading && notas">
        <sgt-nota-card
            *ngFor="let nota of notas"
            [nota]="nota"
            [canEdit]="canEdit"
            (edit)="edit($event)"
            [canDelete]="canDelete"
            (delete)="delete($event)">
        </sgt-nota-card>
    </ng-template>
</div>